:host {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;

    .uic-thumbnail__control {
        display: none;
    }

    .uic-thumbnail__items {
        min-height: 64px;
        -ms-overflow-style: none;
        scroll-behavior: smooth;
        scrollbar-width: none;
        overflow-x: hidden;
        overflow-y: scroll;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    slot {
        display: flex;
        flex-direction: column;
        gap: 0;
    }
}

:host(.uic-thumbnail--controls-visible) {
    .uic-thumbnail__control {
        display: block;
    }
}
